import { FC } from 'react';
import { Skeleton as ChakraSkeleton, SkeletonProps } from '@chakra-ui/react';

export const Skeleton: FC<SkeletonProps> = (props) => {
  // @ts-ignore
  return <ChakraSkeleton {...props} />;
};
